import { Identify, identify, init, track } from '@amplitude/analytics-browser';

import type { TelesittingTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

export const configAmp = (user: TelesittingTypes.User) => {
  init(
    import.meta.env.VITE_API_ENV === 'production'
      ? import.meta.env.VITE_VC_AMPLITUDE_KEY
      : import.meta.env.VITE_VC_AMPLITUDE_KEY_DEV,
    user.domainId,
    { defaultTracking: true },
  );

  const identifyObj = new Identify();
  identifyObj.set('First Name', user.firstName);
  identifyObj.set('Last Name', user.lastName);
  identifyObj.set('Organization', user.orgId);
  identifyObj.set('Role', user.roleDisplayName);
  if (user.unitdisplayName && user.buildingDisplayName)
    identifyObj.set(
      'Unit',
      `${user.buildingDisplayName} ${user.unitdisplayName}`,
    );
  if (user.department) identifyObj.set('Department', user.department);
  if (user.buildingDisplayName)
    identifyObj.set('Building', user.buildingDisplayName);
  identify(identifyObj);
};

export const sendAmpEvent = (
  eventType: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventProperties: Record<string, any> = {},
) => {
  track(eventType, eventProperties);
};
